import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { NC_WEBSITE, SCT_WEBSITE } from '../../../lib/constants';
import { HttpRequestResponse } from '../../../lib/models/http-request-response.model';
import { ApplicationService } from '../../../lib/services/application.service';
import { HttpRequestService } from '../../../lib/services/http-request.service';
import { LogService } from '../../../lib/services/log.service';
import { UtenteService } from '../../../lib/services/utente.service';
import { newError } from '../../../lib/utils/Utility';
import { MenuPortaleComponent } from '../components/menu-portale.component';
import { SectionTitleComponent } from '../components/section-title.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { ScaricaAppComponent } from '../components/scarica-app.component';
import { PortaleLayoutFooterComponent } from '../../layout/portale-layout-footer/portale-layout-footer.component';


@Component({
    selector: 'app-normativa-privacy',
    templateUrl: './normativa-privacy.component.html',
    styleUrls: ['../../../lib/themes/portale.theme.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MenuPortaleComponent, SectionTitleComponent, ReactiveFormsModule, MatCheckbox, RouterLink, MatButton, ScaricaAppComponent, PortaleLayoutFooterComponent]
})
export class NormativaPrivacyComponent {
  private httpRequestService = inject(HttpRequestService);
  private utenteService = inject(UtenteService);
  private router = inject(Router);
  private logService = inject(LogService);
  protected applicationService = inject(ApplicationService);

  urlWebsite: string

  form = new FormGroup({
    accepted: new FormControl(false, [Validators.requiredTrue])
  })

  constructor() {
    const applicationService = this.applicationService;

    if (applicationService.isNextComunica()) {
      this.urlWebsite = NC_WEBSITE
    } else {
      this.urlWebsite = SCT_WEBSITE
    }
  }

  accettaNormativaPrivacy() {
    this.httpRequestService.post('/privacy-policy/accept', { isNc: this.applicationService.isNextComunica() })
      .subscribe((response) => {
        if (HttpRequestResponse.isSuccessResponse(response)) {
          this.checkAbbonamentoScaduto();
        } else {
          this.logService.messageError('Attenzione', response.message, newError(response.message))
        }
      });
  }

  //Controllo via i dati utente se l'abbonamento è scaduto, e reindirizzo l'utente al form di pagamento
  checkAbbonamentoScaduto() {
    if (this.utenteService.mustPay()) {
        this.router.navigate(['impostazioni', 'dati-fatturazione', 'abbonamento-scaduto'], {});
    } else {
        //Se non è scaduto l'abbonamento prima di loggarmi all'applicazione controllo che la password non sia scaduta, e quindi debba essere reimpostata
        this.checkPasswordScaduta()
    }
}

  checkPasswordScaduta() {
    this.httpRequestService
      .get('/siev_fdatamod_password/password/check/expired/', {})
      .subscribe((response) => {
        if (HttpRequestResponse.isSuccessResponse(response)) {
          debugger

          if (response.data?.isPasswordScaduta) {
            this.router.navigate(['/cambioPassword'], { queryParams: { f: 1 }, });
            return
          } else {
            this.router.navigate(['/homepage'], {});
          }
        } else {
          this.logService.messageError('Attenzione!', response.message, newError(response.message));
        }
      });
  }
}
